import { SustainabilityBadge, StyleProvider } from "./components";
import { MetricEmitterProvider } from "./contexts/MetricEmitterContext";
import type { AppProps } from "./types";

export const App = ({ cpfData, settings, assetsBaseUrl }: AppProps) => {
  return (
    <MetricEmitterProvider>
      <StyleProvider
        assetsBaseUrl={assetsBaseUrl}
        colorMode={settings["color-mode"]}
      >
        {cpfData && (
          <SustainabilityBadge cpfData={cpfData} settings={settings} />
        )}
      </StyleProvider>
    </MetricEmitterProvider>
  );
};
